import { HomeItemDetail, HomeItemDetailWidgetType } from '@home-item-detail/entities/home-item-detail';
import { HomeDataResponse } from '@shared/home-sections/entities/home-data.response';

export function mapWidgetsByDetail(detail: HomeItemDetail | HomeDataResponse): HomeItemDetailWidgetType[] {
  const widgets = detail?.widgets ? 
    detail.widgets.replace(/ /g, '').split(',').map(widget => widget.toLowerCase() as HomeItemDetailWidgetType) : [];
  return widgets;
}
